<template>
  <div class="search" ref="searchList">
    <div
      class="search__container"
      @click="inputFocus"
      :class="{ focused: isFocus, 'has-tag': tags.length > 0 }"
    >
      <i class="dp-icon-search search__container-icon" @click="inputFocus"></i>
      <span class="search__container-tag" v-for="(tag, key) in tags" :key="key">
        <span>{{ tag }}</span>
        <i
          class="dp-icon-x search__container-tag-icon"
          @click="removeOneTag(key)"
        ></i>
      </span>
      <input
        ref="searchFocus"
        type="text"
        class="search__container-text"
        v-show="isFocus"
        @blur="focusClear()"
        v-model="search"
        @keydown.enter="addTag"
        @keydown.backspace="removeTag"
      />
      <transition name="fade">
        <ul
          class="search__container-list"
          v-if="isDropdownActive && tags.length !== 0"
        >
          <!-- <dp-loader v-if="isLoading" strokeWidth="6" size="large"></dp-loader> -->
          <dp-loader
            v-if="isLoading"
            size="large"
            strokeColor="#174171"
          ></dp-loader>
          <li
            v-if="this.count == 0 && !isLoading"
            class="search__container-list--item"
          >
            <label class="search__container-list--item-err"
              >Keine Suchergebnisse für
              <strong> {{ searchText }} </strong> gefunden.</label
            >
          </li>
          <li v-else class="search__container-list--item">
            <div
              v-show="!isLoading"
              @click="clickItemOCR(item)"
              class="search__container-list--item-content"
              v-for="(item, key) in documentOCR"
              :key="key"
            >
              <div class="search__container-list--item-content-title">
                {{ item.name }}
              </div>
              <!-- <div class="search__container-list--item-content-badge">
                {{ item.documentCount }}
              </div> -->
            </div>
            <!-- </div> -->
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>
<script>
import { cliendList } from "../../_helper/apiserve";
import { T_BASE_URL, oauthAuthHeader } from "../../utils";
export default {
  name: "SeatchBar",
  data() {
    return {
      model: [],
      search: "",
      tags: [],
      isFocus: false,
      isDropdownActive: false,
      isLoading: true,
      count: 0,
      dataOCR: "",
      searchText: "",
      dataContentOCR: "",

      folderCount: 0,
      folderOCR: [],
      documentCount: 0,
      documentOCR: [],
    };
  },
  methods: {
    inputFocus() {
      this.isFocus = true;
      this.$refs.searchFocus.focus();
    },

    getPerPage() {
      return this.$store.getters.getPerpage;
    },

    documentClick(e) {
      if (this.isDropdownActive == true) {
        try {
          let el = this.$refs.searchList;
          let target = e.target;
          if (el !== target && !el.contains(target)) {
            this.isDropdownActive = false;
          }
        } catch (error) {
          //console.log(error)
        }
      }
    },
    inputClick(e) {
      if (this.isDropdownActive == false) {
        try {
          let el = this.$refs.searchFocus;
          let target = e.target;
          if (el == target && el.contains(target)) {
            this.isDropdownActive = true;
          }
        } catch (error) {
          //console.log(error)
        }
      }
    },

    removeTag(event) {
      this.search = event.target.value;
      if (this.search.length <= 0) this.tags.splice(this.tags.length - 1, 1);
      if (this.tags.length == 0) {
        this.$store.dispatch("addDataOcrAction", "");
        this.$store.dispatch("addDocumentOcrAction", "");
      }
    },
    async clickItemOCR(item) {
      const res = await cliendList(
          "", "", item.name, "", "", "", this.getPerPage()
        );
      const result = await res.json();
      this.$store.dispatch("addRepoClientList", result)
      //cliendList("", "", item.name, "", "", "", this.getPerPage());
      this.isDropdownActive = false;
      this.$store.dispatch("getLoadingAction", true);
      this.$store.dispatch("addDataOcrAction", this.dataOCR);
      this.$store.dispatch("addDocumentOcrAction", item);
    },
    removeOneTag(index) {
      this.tags.splice(index, 1);
      if (this.tags.length == 0) {
        this.$store.dispatch("addDataOcrAction", "");
        this.$store.dispatch("addDocumentOcrAction", "");
      }
    },
    focusClear() {
      if (this.tags.length == 0) {
        this.isFocus = false;
        this.search = "";
      }
    },
    getFolderOCR() {
      this.count = 0;
      this.documentCount = 0;
      this.folderCount = 0;
      this.folderOCR = [];
      this.documentOCR = [];
      fetch(T_BASE_URL + "documentClientList/" + this.getPerPage(), {
        method: "POST",
        headers: {
          ...oauthAuthHeader(),
        },
        body: JSON.stringify({
          search: this.tags,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.status == "successful") {
            this.count = res.count;
            this.dataOCR = res;
            this.dataContentOCR = res.data;
            res.data.forEach((element) => {
              if (element.totalDocument == 0) {
                this.folderCount++;
                this.folderOCR.push(element);
              } else {
                this.documentCount++;
                this.documentOCR.push(element);
              }
            });
          }
          this.isLoading = false;
        })
        .catch();
    },

    addTag(event) {
      this.isLoading = true;
      this.search = event.target.value;
      let matchedTag = false;
      if (this.search.length > 0) {
        if (this.tags.length == 0) {
          this.tags.push(this.search);
          this.search = "";
        } else {
          this.tags.forEach((tag) => {
            if (tag.toLowerCase() == this.search.toLowerCase()) {
              matchedTag = true;
            }
          });
          if (!matchedTag) {
            this.tags.push(this.search);
            this.search = "";
          }
        }
      }
    },
  },
  beforeMount() {
    document.addEventListener("click", this.documentClick);
    document.addEventListener("click", this.inputClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.documentClick);
    document.addEventListener("click", this.inputClick);
  },
  watch: {
    tags() {
      if (this.tags[0]) {
        this.isDropdownActive = true;
        this.getFolderOCR();
      } else {
        this.sDropdownActive = false;
      }

      this.searchText = "";
      this.tags.forEach((element) => {
        if (this.searchText != element) this.searchText += element + " ";
      });
      if (this.tags.length < 1) {
        cliendList(
          "",
          "",
          "",
          "",
          localStorage.getItem("lastWeek"),
          localStorage.getItem("today"),
          this.getPerPage()
        );
      }
    },
  },
};
</script>

<style lang="scss">
@media only screen and (min-width: 600px) {
  .focused {
    width: 100px !important;
  }
}
@media only screen and (min-width: 768px) {
  .focused {
    width: 200px !important;
  }
}
@media only screen and (min-width: 900px) {
  .focused {
    width: 300px !important;
  }
}
@media only screen and (min-width: 1000px) {
  .focused {
    width: 400px !important;
  }
}
@media only screen and (min-width: 1130px) {
  .focused {
    width: 300px !important;
  }
}
@media only screen and (min-width: 1200px) {
  .focused {
    width: 450px !important;
  }
}
.fade-enter {
  opacity: 0;
}
.fade-enter-active {
  transition: opacity 0.2s;
}

.fade-leave-active {
  opacity: 0;
  transition: opacity 0.2s;
}
.search {
  position: relative;
  margin-right: -1.6rem;
  &__container {
    cursor: pointer;
    border-radius: 4px !important;
    display: flex;
    align-items: center;
    height: 2.65rem;
    transition: width 0.1s ease-in-out;
    overflow: hidden;
    width: 30px;
    min-width: 0.5rem;
    padding-left: 0.75rem;
    // &:hover {
    //   background-color: #fff;
    //   width: 450px;
    //   border: 1px solid red;
    // }
    &-icon {
      width: 1rem !important;
      color: #174171;
      margin-right: 4px;
      margin-top: 6px !important;
      font-weight: 500 !important;
      padding-bottom: 4px;
    }
    &-placeholder {
      font-size: 12px;
      font-weight: 400;
      width: calc(100% - 40px);
    }
    &-text {
      background-color: transparent;
      border: none;
      width: calc(100% - 40px);
      color: #181616;
      font-weight: 500;
      font-size: 12px;
      padding-left: 4px;
    }
    &-tag {
      font-weight: 600;
      padding: 0 0.25rem;
      background-color: rgb(209, 217, 227);
      color: #174171;
      border: 1px solid rgb(209, 217, 227);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 12px;
      line-height: 1;
      padding: 0.25rem;
      white-space: nowrap;
      margin-left: 0.75rem;
      & > span {
        margin-right: 0.25rem;
      }
      &:not(:last-child) {
        margin-right: 0.05rem;
      }
      &-icon {
        font-weight: 500 !important;
      }
    }
    &-list {
      position: absolute;
      z-index: 100;
      width: inherit;

      right: 15px;
      top: 35px;
      border-radius: 4px;
      background-color: #fff;
      box-shadow: 0 2px 4px 0 #9c9c9c;
      padding: 0;
      min-height: 50px;
      max-height: 500px;
      overflow-y: scroll;
      &::-webkit-scrollbar {
        width: 5px;
      }

      /* Track */
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px transparent;
        border-radius: 5px;
      }

      /* Handle */
      &::-webkit-scrollbar-thumb {
        background: #9b9b9b;
        border-radius: 5px;
      }

      /* Handle on hover */
      &::-webkit-scrollbar-thumb:hover {
        background: #9b9b9b;
      }
      max-height: 300px;
      height: auto !important;
      border-style: none !important;
      &:hover {
        background-color: white;
      }
      &--item {
        list-style: none;
        margin-top: 14px !important;
        align-items: center;
        text-align: start;
        margin-left: 3px;
        font-size: 13.5px;

        cursor: default;
        transition: all 0.3s ease-in-out;
        &:first-of-type {
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
        }
        &:last-of-type {
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
        }
        &-err {
          padding: 1rem;
          color: #174171;
        }
        &-content {
          padding: 0.75rem 1rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          &:hover {
            color: #174171;
            background-color: rgba($color: #4a90e2, $alpha: 0.1);
          }
          &-badge {
            border-radius: 50%;
            color: #174171;
            font-weight: 600;
            background-color: rgba($color: #174171, $alpha: 0.2);
            width: 23px;
            height: 23px;
            text-align: center;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.8rem;
          }
          &-title {
            font-size: 0.8rem;
            font-weight: 500;
            color: #174171;
          }
        }
      }
    }
  }
}
.focused {
  background-color: #fff;
  width: 450px;
  border: 1px solid #174171;
  margin-right: 10px;
  text-align: center;
  justify-items: center;
  .search__input-icon {
    cursor: default;
    margin-bottom: 20px;
    &:hover {
      background-color: transparent;
    }
  }
}
.has-tag .search__input-text {
  width: calc(100% - 80px);
}

.paddingLeft {
  padding-left: 80px !important;
}
.header__search {
  position: relative;
  display: flex;
  align-items: center;
  width: 100px;
  transition: all 0.4s ease-in-out;
  z-index: 100;
  &--input {
    width: 100%;
    border-radius: 4px;
    background-color: #f3f5f8;
    border: 1px solid #b9c6d4;
    font-size: 1rem;
    color: #174171;
    padding: 4px 28px;
  }
  &:focus-within {
    width: 450px;
  }
  &--iconSearch {
    position: absolute;
    z-index: 100;
    font-size: 1rem;
    color: #174171;
    padding-left: 6px;
    font-weight: 600 !important;
  }
  &--iconX {
    font-size: 1rem;
    color: #174171 !important;
    cursor: pointer;
    position: absolute;
    right: 10px;
    margin-top: 0.25rem;
  }
  &--tag {
    position: absolute;
    z-index: 100;
    padding-left: 30px;
    font-weight: 600;
  }
}
.dp-loader--large {
  margin: 1% 50% !important;
  position: absolute !important;
  stroke-width: 5 !important;
  stroke: #174171 !important;
}
</style>
